import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../LanguageContext";
import instaPreviewEN from "../assets/landing/ACT2.png";
import instaPreviewID from "../assets/landing/ACT2.png";

const OurActivities = () => {
  const { language } = useLanguage();

  const text = {
    en: {
      title: "OUR ACTIVITY",
      description:
        "Follow our latest moments, innovations, and behind-the-scenes stories through our Instagram feed.",
      instagram: "Visit our Instagram",
      username: "micronet.el",
      image: instaPreviewEN,
    },
    id: {
      title: "KEGIATAN KAMI",
      description:
        "Ikuti momen terbaru, inovasi, dan cerita di balik layar kami melalui feed Instagram.",
      instagram: "Kunjungi Instagram Kami",
      username: "micronet.el",
      image: instaPreviewID,
    },
  };

  const t = text[language] || text.en;

  return (
    <section
      id="activities"
      className="
        bg-white 
        flex flex-col lg:flex-row 
        items-center justify-between 
        px-6 sm:px-10 md:px-16 lg:px-28 
        py-16 sm:py-20 md:py-24 
        gap-10 sm:gap-14 md:gap-20
        mt-20
      "
    >
      <motion.div
        className="w-full lg:w-[55%] flex justify-center items-center"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div
          className="
            relative 
            w-full 
            max-w-[380px] sm:max-w-[600px] md:max-w-[700px] lg:max-w-[900px]
          "
        >
          <img
            src={t.image}
            alt="Instagram Mockup"
            className="
              w-full 
              h-auto 
              object-contain 
              rounded-3xl 
              hover:scale-[1.03] 
              transition-transform 
              duration-300
            "
          />

          
        </div>
      </motion.div>
      
      <motion.div
        className="
          w-full lg:w-1/2 
          text-center lg:text-left 
          flex flex-col justify-center items-center lg:items-start
        "
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#1446A5] mb-6 sm:mb-8">
          {t.title}
        </h2>
        <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed mb-6 sm:mb-8 max-w-md">
          {t.description}
        </p>

        <a
          href="https://www.instagram.com/micronet.el"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#1446A5] font-semibold text-lg sm:text-xl flex items-center gap-2 hover:underline transition-all duration-200"
        >
          {t.instagram}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
            />
          </svg>
        </a>
      </motion.div>
    </section>
  );
};

export default OurActivities;
